/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../../static/less/loyalty.less';
import '../../static/images/loading5.gif';
import '../../static/less/new_shopping_cart/login2.css';
import CloseIcon from '../icons/CloseIcon';
import {
  login, setShowLogin, setShowRecoverPassword,
  setShowRegistration, setShowLastChanceToRegister,
  checkRegistrationEmail, resendActivationLink,
} from '../../actions/Loyalty';
//import Checkbox from '../common/Checkbox';
import bestRate from '../../static/images/bestRate.png';
import dollarIcon from '../../static/images/dollarIcon.png';
import bxsBadge from '../../static/images/bxsBadge.png';
import sandos4uWhite from '../../static/images/sandos4uWhite.png';
import { DEVICES } from '../../actions/Booking';

import { setCookie } from '../../services/cookies';
import LoyaltyEmailStatusHelp, { getEmailInputStatusClass } from './LoyaltyEmailStatusHelp';
import LoyaltyActivationLinkSentModal from './LoyaltyActivationLinkSentModal';
import {
  EMAIL_FORM, EMAIL_STATUS, EmailStatusChecker, canResendActivationLink, getInitialEmailCheckState,
  isAccountNotActivatedMessage, isSubmitBlockedByEmailStatus, normalizeEmail, RESEND_ERROR_THROTTLED,
} from '../../utils/loyaltyEmailStatus';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: { // email or card code
        name: 'username', value: '', valid: undefined, msg: '', required: true,
      },
      password: {
        name: 'password', value: '', valid: undefined, msg: '', required: true,
      },
      rememberMe: {
        name: 'rememberMe', value: false, valid: undefined, msg: '', required: false,
      },
      loading: false,
      loginError: null,
      passwordShown: false,
      // Pre-check del email en loyalty (checkRegistrationEmail)
      ...getInitialEmailCheckState(),
    };

    this.emailChecker = new EmailStatusChecker({
      check: (email) => this.props.dispatch(checkRegistrationEmail(email)),
      onUpdate: (update) => this.setState(update),
    });
  }

  componentWillUnmount() {
    this.emailChecker.dispose();
  }

  openRecoverPasswordModal = () => {
    this.props.dispatch(setShowRecoverPassword(true));
    this.props.dispatch(setShowLogin(false));
    this.props.dispatch(setShowLastChanceToRegister(false));
  }

  onChangeValue = (fieldName, event) => {
    const { target } = event;
    let value = target.type === 'checkbox' ? target.checked : target.value;

    // El email siempre en minúsculas (al teclear o pegar)
    const isUsername = fieldName === 'username';
    if (isUsername && typeof value === 'string') {
      value = value.toLowerCase();
    }

    const updatedState = {
      value,
    };

    this.setState({ [fieldName]: { ...this.state[fieldName], ...updatedState } }, () => {
      // Evita que el cursor salte al final al editar en medio del texto
      if (isUsername && target.setSelectionRange && target.type !== 'email') {
        const pos = target.selectionStart;
        target.setSelectionRange(pos, pos);
      }
    });
    if (isUsername) {
      this.setState({ resendError: '' });
      this.emailChecker.schedule(value);
    }
  }

  /*
  * Tras un login fallido: si loyalty indica que la cuenta no está activada, o si al
  * reconsultar el check el email está PENDING / UNSUBSCRIBED / BLOCKED, mostramos ese
  * mensaje bajo el email. En cualquier otro caso un único mensaje genérico, sin distinguir
  * si falló el email o el password (no enumerar cuentas).
  */
  applyLoginFailure = async (response) => {
    if (!response) {
      this.setState({ loading: false, loginError: this.context.t('An error has occurred trying login') });
      return;
    }

    const email = this.state.username.value;
    if (isAccountNotActivatedMessage(response.error_message)) {
      this.emailChecker.cancel();
      this.setState({
        loading: false,
        loginError: null,
        emailStatus: EMAIL_STATUS.PENDING_VERIFICATION,
        emailCheckLoading: false,
        emailCheckFailed: false,
        emailCheckedValue: normalizeEmail(email),
      });
      return;
    }

    const status = await this.emailChecker.checkNow(email);
    this.setState({
      loading: false,
      loginError: isSubmitBlockedByEmailStatus(EMAIL_FORM.LOGIN, status)
        ? null
        : this.context.t('Incorrect email address or password. Please verify your details and try again.'),
    });
  };

  login = (event) => {
    event.preventDefault();
    if (this.state.loading || isSubmitBlockedByEmailStatus(EMAIL_FORM.LOGIN, this.state.emailStatus)) {
      return;
    }
    this.setState({ loading: true, loginError: null });
    const { username } = this.state;
    this.props.dispatch(login({ email: username.value.trim().toLowerCase(), password: this.state.password.value }))
      .then((response) => {
        if (!response || !response.success) {
          this.applyLoginFailure(response);
          return;
        }
        this.setState({ loading: false, loginError: null });
        if (this.state.rememberMe.value) {
          const expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 100);
          setCookie(
            'login-details',
            JSON.stringify({
              username: this.state.username.value,
              password: this.state.password.value,
            }),
            expireDate);
        }
        this.props.dispatch(setShowLogin(false));
        this.props.dispatch(setShowLastChanceToRegister(false));
        this.props.dispatch(setShowRegistration(false));
      })
      .catch(() => {
        this.setState({ loading: false, loginError: this.context.t('An error has occurred trying login') });
      });
  };

  renderLoading() {
    if (!this.state.loading) {
      return null;
    }
    return (
      <div className={'loading'}>
        <img src={'/img/loading5.gif'}/>
        <p>{this.context.t('Wait a moment, please...')}</p>
      </div>
    );
  }

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  }

  // PENDING_VERIFICATION / UNSUBSCRIBED -> reenviar link de activación
  onResendActivationLink = () => {
    const email = this.state.username.value.trim();
    if (this.state.isResending || !canResendActivationLink(this.state.emailStatus) || !email) {
      return;
    }
    this.setState({ isResending: true, resendError: '' });
    this.props.dispatch(resendActivationLink(email))
      .then(() => {
        this.setState({ isResending: false, showLinkSentModal: true });
      })
      .catch((error) => {
        this.setState({
          isResending: false,
          resendError: error && error.code === RESEND_ERROR_THROTTLED
            ? this.context.t('Please wait a moment before requesting another link.')
            : this.context.t('We could not send the link. Please try again.'),
        });
      });
  };

  // En login sólo se cierra el popup de éxito; el login se queda abierto y limpio
  onCloseLinkSentModal = () => {
    this.emailChecker.cancel();
    this.setState({
      ...getInitialEmailCheckState(),
      username: { ...this.state.username, value: '' },
      password: { ...this.state.password, value: '' },
      loginError: null,
    });
  };

  onClickRegister = () => {
    this.props.dispatch(setShowLogin(false));
    this.props.dispatch(setShowLastChanceToRegister(false));
    this.props.dispatch(setShowRegistration(true));
  };

  dismissLogin = () => {
    this.props.dispatch(setShowLogin(false));
  };

  render() {
    // En login sólo PENDING_VERIFICATION / UNSUBSCRIBED / BLOCKED muestran mensaje y bloquean el envío
    const loginBlocked = isSubmitBlockedByEmailStatus(EMAIL_FORM.LOGIN, this.state.emailStatus);
    const emailHelpVisible = loginBlocked;

    return (
      <div className={'loyaltyLogin'}>
        <div className={'backdrop'} onClick={() => this.dismissLogin()}/>
          <div className={'content content2'}>
            {this.renderLoading()}
            <CloseIcon onClick={() => this.dismissLogin()}/>
            <div className="login-wrapper">
            <div className="loyaltyCenterImage">
              <img
                src={sandos4uWhite}
                alt="Tarifa garantizada"
              />
            </div>
            <div className="login-container">
              <div className="info-section">
                <h1 className="title">{this.context.t('JOIN SANDOS4U')}</h1>
                <ul className="features-list">
                  <li className="feature-item">
                    <div className="feature-icon">
                      <img src={bestRate} alt="Tarifa garantizada" />
                    </div>
                    <div className="feature-text">
                      <h3 className="lineHeight1_2">{this.context.t('BEST RATE GUARANTEED')}</h3>
                      {this.props.isMobile === false
                        && <p>
                          {this.context.t('Just by being a member you get access to a preferential rate.')}
                        </p>
                      }
                    </div>
                  </li>
                  <li className="feature-item">
                    <div className="feature-icon">
                      <img src={dollarIcon} alt="Tarifa garantizada" />
                    </div>
                    <div className="feature-text">
                      <h3 className="lineHeight1_2">{this.context.t('WIN COINS FOR EACH RESERVATION')}</h3>
                      {this.props.isMobile === false
                        && <p>
                          {this.context.t('When you check out you will get Coins that will be added to your account.')}
                        </p>
                      }
                    </div>
                  </li>
                  <li className="feature-item">
                    <div className="feature-icon">
                      <img src={bxsBadge} alt="Tarifa garantizada" />
                    </div>
                    <div className="feature-text">
                      <h3 className="lineHeight1_2">{this.context.t('REDEEM YOUR COINS FOR PRIZES AND STAYS')}</h3>
                      {this.props.isMobile === false
                        && <p>
                          {this.context.t('Exchange your coins for incredible prizes.')}
                        </p>
                      }
                    </div>
                  </li>
                </ul>
              </div>

              <div className="form-section">
                <h2>{this.context.t('Login with your email')}</h2>
                <form onSubmit={this.login} className='Login2Form'>
                  <input
                    type="email"
                    placeholder={this.context.t('Email')}
                    value={this.state.username.value}
                    onChange={(ev) => this.onChangeValue('username', ev)} // Pass 'username' and event
                    className={[
                      this.props.isMobile ? 'input-fieldMobile' : 'input-field', // Condicional para clase
                      getEmailInputStatusClass(
                        EMAIL_FORM.LOGIN,
                        this.state.emailStatus,
                        this.state.emailCheckLoading,
                        this.state.emailCheckFailed,
                      ),
                      emailHelpVisible ? 'loyaltyEmailInput--hasHelp' : '',
                    ].filter(Boolean).join(' ')}
                    aria-describedby="loyalty_login_email_status"
                    autoComplete="email"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    required
                  />
                  {this.state.loginError && <div className={'login2Error'}>{this.state.loginError}</div>}
                  <LoyaltyEmailStatusHelp
                    id="loyalty_login_email_status"
                    t={this.context.t}
                    form={EMAIL_FORM.LOGIN}
                    status={this.state.emailStatus}
                    loading={this.state.emailCheckLoading}
                    checkFailed={this.state.emailCheckFailed}
                    isResending={this.state.isResending}
                    resendError={this.state.resendError}
                    onResend={this.onResendActivationLink}
                    onDark
                  />
                  <input
                    type="password"
                    placeholder={this.context.t('Password')}
                    value={this.state.password.value}
                    onChange={(ev) => this.onChangeValue('password', ev)} // Pass 'password' and event
                    className={this.props.isMobile ? 'input-fieldMobile' : 'input-field'} // Condicional para clase
                    autoComplete="current-password"
                    required
                  />
                  {/*{!this.state.showRecoverPassword && <Checkbox
                  id="rememberMe"
                  label={this.context.t('Remember me')}
                  checked={this.state.rememberMe.value}
                  onChange={(ev) => this.onChangeValue(this.state.rememberMe.name, ev)}
                  />}*/}
                  <button className="submit-btn" type={'submit'} disabled={loginBlocked}>
                    {this.context.t('Enter')}
                  </button>
                </form>
                <a onClick={ this.openRecoverPasswordModal }className="forgot-link">
                  { this.context.t('Recover password') }
                </a>
                <p className="signup-prompt">{this.context.t('Not a member of Sandos4U yet?')}</p>
                <button className="create-account-btn" onClick={() => this.onClickRegister()}>{this.context.t('Register')}</button>
                {this.props.isMobile === true && <div className='spaceForMobileUserLogin'></div>}
              </div>
            </div>
          </div>
        </div>
        {this.state.showLinkSentModal && (
          <LoyaltyActivationLinkSentModal t={this.context.t} onClose={this.onCloseLinkSentModal} />
        )}
      </div>
    );
  }
}

Login.propTypes = {
  chainData: PropTypes.object.isRequired,
  loggedUser: PropTypes.object,
};

Login.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
});

export default connect(mapStateToProps)(Login);
